export enum AiDtosKeysEnum {
  /** FRM AI chat response body */
  AI_CHAT_FIND_DTO = 'ai/chat-find.dto',
  /** FRM AI chat create request body */
  AI_CHAT_FORM_DTO = 'ai/chat-form.dto',
  /** FRM AI chat send message request body */
  AI_CHAT_SEND_MESSAGE_FORM_DTO = 'ai/chat-send-message-form.dto',
  /** FRM AI chat query parameters */
  AI_CHAT_QUERY_DTO = 'ai/chat-query.dto',
  /** FRM AI chat partial update request body */
  AI_CHAT_PARTIAL_FORM_DTO = 'ai/chat-partial-form.dto',
  /** FRM AI chat reorder request body */
  AI_CHAT_REORDER_FORM_DTO = 'ai/chat-reorder-form.dto',
  /** FRM AI chat group response body */
  AI_CHAT_GROUP_FIND_DTO = 'ai/chat-group-find.dto',
  /** FRM AI chat group create request body */
  AI_CHAT_GROUP_FORM_DTO = 'ai/chat-group-form.dto',
  /** FRM AI chat group partial update request body */
  AI_CHAT_GROUP_PARTIAL_FORM_DTO = 'ai/chat-group-partial-form.dto',
  /** FRM AI chat group reorder request body */
  AI_CHAT_GROUP_REORDER_FORM_DTO = 'ai/chat-group-reorder-form.dto',
  /** FRM AI chat context info response body */
  AI_CHAT_CONTEXT_INFO_DTO = 'ai/chat-context-info.dto',
  /** FRM AI chat delete-out-of-context result response body */
  AI_CHAT_DELETE_OUT_OF_CONTEXT_RESULT_DTO = 'ai/chat-delete-out-of-context-result.dto',
  /** Voice assistant "open form" API response body */
  VOICE_ASSISTANT_OPEN_FORM_DTO = 'ai/voice-assistant-open-form.dto',
}
